import en from './advanceStrings.en';

export default {
  en,
};
